import { SvgProps } from "../../types";

const DataUsageSvg = (props: SvgProps) => (
  <svg
    {...props}
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.52381 19C8.20635 19 6.96825 18.75 5.80952 18.25C4.65079 17.75 3.64286 17.0675 2.78571 16.2024C1.92857 15.3373 1.25 14.3254 0.75 13.1667C0.25 12.0079 0 10.7778 0 9.47619C0 6.98413 0.825397 4.84127 2.47619 3.04762C4.12698 1.25397 6.15873 0.238095 8.57143 0V2.85714C6.93651 3.07937 5.5754 3.81349 4.4881 5.05952C3.40079 6.30556 2.85714 7.77778 2.85714 9.47619C2.85714 11.3175 3.50794 12.8889 4.80952 14.1905C6.11111 15.4921 7.68254 16.1429 9.52381 16.1429C10.5714 16.1429 11.5516 15.9206 12.4643 15.4762C13.377 15.0317 14.1429 14.4286 14.7619 13.6667L17.2381 15.0952C16.381 16.2857 15.2778 17.2341 13.9286 17.9405C12.5794 18.6468 11.1111 19 9.52381 19ZM18.2381 13.3333L15.7619 11.9048C15.9048 11.5238 16.0119 11.131 16.0833 10.7262C16.1548 10.3214 16.1905 9.90476 16.1905 9.47619C16.1905 7.77778 15.6468 6.30556 14.5595 5.05952C13.4722 3.81349 12.1111 3.07937 10.4762 2.85714V0C12.8889 0.238095 14.9206 1.25397 16.5714 3.04762C18.2222 4.84127 19.0476 6.98413 19.0476 9.47619C19.0476 10.1746 18.9841 10.8492 18.8571 11.5C18.7302 12.1508 18.5238 12.7619 18.2381 13.3333Z"
      fill={props.fill ? props.fill : "#1064ED"}
    />
  </svg>
);
export default DataUsageSvg;
